module.exports = __webpack_public_path__ + "static/media/club-oro.c41fd48f.png";